/* eslint-disable no-nested-ternary */
import React from 'react';
import { motion } from 'framer-motion';
import { colorPalette } from '@lib/constants';
import { parseColorToRgba } from '@services/interactions-service';

const LeaderboardItem = ({
  leaderboard,
  colors,
  animatedCount,
  animatedRelativePercentage,
  isLeaderboard,
  fontSize
}) => {
  const chartColor = colors?.pollChartColor ?? '#F97B5F';
  const textColor = colors?.pollLabelColor ?? '#000000';
  const barColor = parseColorToRgba(chartColor, 1);
  const resolvedTextColor = barColor === parseColorToRgba(textColor, 1) ? '#000000' : textColor;

  return (
    <div className="w-full inline-flex flex-col justify-start items-start gap-4">
      {leaderboard.map(({ id, commenterName }, index) => {
        const fallbackCount = leaderboard[index]?.totalScore ?? leaderboard[index]?.count ?? 0;
        const countToDisplay = id !== undefined && animatedCount[id] !== undefined ? animatedCount[id] : fallbackCount;

        const fallbackPercentage = leaderboard[index]?.relativePercentage ?? 0;
        const percentageToDisplay = id !== undefined && animatedRelativePercentage[id] !== undefined ? animatedRelativePercentage[id] : fallbackPercentage;

        return (
          <motion.div
            key={id || index}
            layoutId={String(id || index)}
            style={{ background: parseColorToRgba(chartColor, 0.4) }}
            className="relative w-full h-20 rounded-[50px] overflow-hidden"
            layout
            transition={{ type: 'spring', stiffness: 60, damping: 20, duration: 5 }}
          >
            {/* Animated progress fill — sits behind the content */}
            <motion.div
              style={{ background: barColor }}
              className="absolute inset-y-0 left-0"
              initial={{ width: 0 }}
              animate={{ width: `${percentageToDisplay}%` }}
              transition={{ duration: 5, ease: 'easeOut' }}
            />

            {/* Foreground row: avatar + name on the left, count on the right */}
            <div className="relative z-10 w-full h-full flex items-center justify-between gap-4 pr-6">
              <div className="flex items-center gap-4 h-full min-w-0">
                <div
                  className="h-full aspect-square rounded-full flex justify-center items-center shrink-0"
                  style={{ backgroundColor: colorPalette[index % colorPalette.length] }}
                >
                  <div className="text-[#212121] text-3xl font-semibold leading-[34.50px]">
                    {commenterName?.charAt(0)}
                  </div>
                </div>
                <div
                  style={{ fontSize, color: resolvedTextColor }}
                  className="font-normal leading-[48px] line-clamp-1"
                >
                  {commenterName}
                </div>
              </div>

              <motion.div
                style={{ color: resolvedTextColor }}
                className="text-3xl font-normal leading-[48px] shrink-0"
              >
                {countToDisplay}{isLeaderboard && 'p'}
              </motion.div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default LeaderboardItem;
